export const UPDATE_HEADER_COLOR = "UPDATE_HEADER_COLOR"
export const SET_ACTIVE_FOOTER_BTN = "SET_ACTIVE_FOOTER_BTN"
